import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { ImageMarquee } from './ImageMarquee';
import { collection } from '../data/content';
export function Collection() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="collection-heading" data-id="element-26" data-mp="2w9y6yubfbrln">
      <div className="mx-auto max-w-6xl px-5" data-id="element-27" data-mp="2rb4t30s85yky">
        <div id="collection-heading" data-id="element-28" data-mp="2r88tl80qb1ue">
          <SectionHeading eyebrow="Discover what's inside" title="A whole little world she can create today" data-id="element-29" data-mp="3oy3t9li4lonl" />
        </div>

        <div className="mt-8" data-id="element-30" data-mp="3jwwkbj48yjfc">
          <ImageMarquee data-id="element-31" data-mp="3ez4sep3lqxb5" />
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-32" data-mp="3ey36tqoymsf6">
          {collection.map((item, index) => <motion.article key={item.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45,
          delay: index * 0.08
        }} className="flex gap-4 rounded-3xl border-2 border-white bg-white p-6 shadow-card" data-id="element-33" data-mp="3a0bfoyw53ac1" data-mpi={index}>
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-lilac-100 text-2xl" aria-hidden="true" data-id="element-34" data-mp="zeqgli0knkhc">
                {item.emoji}
              </span>
              <div data-id="element-35" data-mp="pjowj0l5l8lm">
                <h3 className="font-display text-xl font-bold text-ink" data-id="element-36" data-mp="bqqtqt6dse81">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-ink/70" data-id="element-37" data-mp="gh78cglxu5vz">{item.text}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}